import React from "react";
import { useDispatch } from "react-redux";
import { handleRightDrawer } from "../../actions/actionCreators";
import moment from "moment";
import Folder from "../../icons/Folder";

interface Props {
  notif: any;
  inPage: boolean;
  position: boolean;
}

export const NewCollectionDemco = ({ inPage, notif, position }: Props) => {
  const dispatch = useDispatch();
  return inPage ? (
    <div className="notif_item_page p-2 my-2">
      <div className="d-flex align-items-center">
        <div className="mx-2 d-flex align-items-center icon_notif_container">
          <Folder />
        </div>
        <h2 className="h4_medium m-0">
          A new collection has just been Uploaded
        </h2>
      </div>
      <p className="selection_date m-0">{moment(notif.created_at).fromNow()}</p>
    </div>
  ) : (
    <div
      className="notif_added_prod_container"
      onClick={() => dispatch(handleRightDrawer())}
      style={{
        borderRadius: "8px",
        background: position ? "#e5f1fa" : "white",
        transition: "all 5s ease-in-out",
      }}
    >
      <article className="notif_selection order_changes my-3">
        <Folder />
        <div className="notif_details">
          <h2 className="h4_medium">A new collection has just been Uploaded</h2>
          <div>
            <p
              className="selection_date"
              style={{ fontSize: "0.7rem", fontWeight: 400 }}
            >
              {moment(notif.created_at).fromNow()}
            </p>
          </div>
        </div>
      </article>
    </div>
  );
};
